/* eslint-disable import/prefer-default-export */
export const returnAccessibility = study => study?.config?.participant_accessibility
